import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "../axiosBaseQuery";
import { IDemandPayload } from '../../interface/IDemand';

export const demandApi = createApi({
  reducerPath: 'demandApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    forecastOverViewDropDownFilter: builder.mutation({
      query: (payload: IDemandPayload) => ({
        url: "/forecastOverViewDropDownFilter",
        method: 'POST',
        data: payload,
      }),
    }),
    getFeatchForecastoverView: builder.mutation({
      query: (payload: IDemandPayload)=>({
        url: "/getFeatchForecastoverView",
        method: 'POST',
        data: payload
      })
    }),
    getForecastOverviewBarchat: builder.mutation({
      query: (payload: IDemandPayload)=>({
        url: "/getForecastOverviewBarchat",
        method: 'POST',
        data: payload,
      })
    }),
    getForecastoverViewMap: builder.mutation({
      query: (payload: IDemandPayload)=>({
        url: "/getForecastoverViewMap",
        method: 'POST',
        data: payload
      })
    }),
    getForecastOverViewMapStoreLevel: builder.mutation({
      query: (payload: IDemandPayload)=>({
        url: "/getForecastOverViewMapStoreLevel",
        method: 'POST',
        data: payload
      })
    })
  }),
});

export const {
  useForecastOverViewDropDownFilterMutation,
  useGetFeatchForecastoverViewMutation,
  useGetForecastOverviewBarchatMutation,
  useGetForecastoverViewMapMutation,
  useGetForecastOverViewMapStoreLevelMutation
} = demandApi;
